import { Store } from 'redux';
import { coreLocationApi } from '@cp/entities/location';
import { CityViewModel } from '../../../../../common/model/location/cityViewModel';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getCurrentCityFromStore = (store: Store<any, any>, cityAlias: string | undefined): CityViewModel | undefined => {
  const { data } = coreLocationApi.endpoints.getCities.select({ alias: cityAlias ?? '' })(store.getState());
  return data?.[0];
};
